import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import Contract from '../components/Contract';

const mapStateToProps = (state, initialProps) => {
    let contract_accepted = (formValueSelector(initialProps.form))(state, 'contract_accepted')
    return {
        contractValue: (typeof(contract_accepted) !== 'undefined' && true),
    }
}

export default connect(mapStateToProps, null)(Contract);



/** WEBPACK FOOTER **
 ** ./src/containers/ContractContainer.js
 **/